import { render } from "./wbs.vue?vue&type=template&id=7d566e7e"
import script from "./wbs.vue?vue&type=script&lang=js"
export * from "./wbs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__